var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FarmsTable',{ref:"FarmsTable",attrs:{"idFarm":_vm.item.ID,"editorName":_vm.item.EDITOR_NAME,"lastUpdate":_vm.item.UPDATE,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }